/** Merge ticket rows by id for list polling (newest last_message_at wins). */
export function mergeTicketRows(prev, incoming) {
  if (!incoming?.length) return prev || [];
  const byId = new Map((prev || []).map((t) => [t.id, t]));
  for (const t of incoming) {
    if (t?.id) byId.set(t.id, { ...(byId.get(t.id) || {}), ...t });
  }
  return [...byId.values()].sort(
    (a, b) => new Date(b.last_message_at || 0) - new Date(a.last_message_at || 0),
  );
}
